// Copyright (c) 2017 Deere & Company

import {
    applySearchFilters,
    resetAllFacets,
    selectAllClaimStatusOnInitialLoad,
    selectAllDealersOnInitialLoad,
    toggleClaimStatusFacetItems,
    toggleClaimTypeFacetItems,
    toggleDealerAccountFacetItems,
    updateClaimStatusFacetItem,
    updateClaimTypeFacetItem,
    updateDateRangeFacet,
    updateDateType,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem
} from './facets';
import {
    onCreateClaim,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateSearchResults
} from './claim-search';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {handleSearchAction} from './handle-search-action';
import {onSearch} from '../../shared/action-creators/search';
import {readAllClaims} from '../../all-claims/action-creators/all-claims';
import {readClaimTypes} from './get-claim-types';
import {readDealerInvoices} from '../../dealer-invoices/action-creators/read-dealer-invoices';
import {readFacetsData} from './read-facets-data';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateSearchByDropDown} from '../../shared/action-creators/search-by-dropdown';
import {updateSearchQueryString} from '../../shared/action-creators/search-query-string';

export default {
    ...exportToExcelActions,
    applySearchFilters,
    handleSearchAction,
    onCreateClaim,
    onSearch,
    readAllClaims,
    readClaimTypes,
    readDealerInvoices,
    readFacetsData,
    resetAllFacets,
    selectAllClaimStatusOnInitialLoad,
    selectAllDealersOnInitialLoad,
    toggleClaimStatusFacetItems,
    toggleClaimTypeFacetItems,
    toggleDealerAccountFacetItems,
    toggleReportsAccordion,
    updateClaimStatusFacetItem,
    updateClaimTypeFacetItem,
    updateCreateClaimModalVisibility,
    updateDateRangeFacet,
    updateDateType,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateSearchByDropDown,
    updateSearchQueryString,
    updateSearchResults
};



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/index.js